import { render } from "@/share/components/pages/oldBrowserError/OldBrowserError.html?vue&type=template&id=4d154194&scoped=true&external"
const script = {}

import "@/share/components/pages/oldBrowserError/OldBrowserError.scss?vue&type=style&index=0&id=4d154194&lang=scss&scoped=true&external"

import exportComponent from "../../../../execute/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d154194"]])

export default __exports__